import React, { FC, useCallback, useEffect, useState } from 'react'
import './MoreViewedProgramsModule.scss'
import { ICourse } from 'app_types/campus/academic/courseTypes'
import CourseService from 'app_services/campus/academic/courseService'
import LoadingWrapper from 'app_components/commons/LoadingWrapper/LoadingWrapper'
import useWindowWidth from 'app_hooks/useWindowWidth'
import Slider from 'react-slick'
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs'
import FilterCourseCard from 'app_components/screens/landing/AcademicFilterScreen/components/FilterCourseCard/FilterCourseCard'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { routingService } from '../../../services/routingService';
import { CourseSchedulingCourseType } from 'app_types/admin/courseScheduling/courseSchedulingTypes'

const PER_PAGE = 8
const MOVIL_BREAKPOINT = 760
const CARD_WIDTH = 350

interface IMoreViewedProgramsModuleProps {

}

const MoreViewedProgramsModule: FC<IMoreViewedProgramsModuleProps> = () => {
  const [courses, setCourses] = useState<ICourse[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { windowWidth } = useWindowWidth()
  const [cardHeight, setCardHeight] = useState<number>()
  const isMovil = windowWidth && windowWidth <= MOVIL_BREAKPOINT

  useEffect(() => {
    if (courses?.length && windowWidth > MOVIL_BREAKPOINT) {
      setTimeout(() => {
        const sliderContainer = document.querySelector('.more-viewed-programs--slider')
        if (sliderContainer) {
          setCardHeight(sliderContainer.clientHeight - 16)
        }
      }, 100)
    }
  }, [courses, windowWidth])

  const getCourses = useCallback(async () => {
    setIsLoading(true)
    const courseService = new CourseService()
    const response = await courseService.fetchCourses({
      endPublicationDate: {date: "today", direction: "gte"},
      startPublicationDate: {date: "today", direction: "lte"},
      nPerPage: PER_PAGE,
      pageNumber: 1,
      publish: true,
      moreViewed: true
    })

    if(response){
      setCourses(response.courses)
    } else {
      setCourses([])
    }
    setIsLoading(false)
  }, [])


  useEffect(() => {
    getCourses()
  }, [getCourses])

  const getNumberItems = () => {
    const widthCard = CARD_WIDTH
    const totalItems = Math.round((windowWidth - 200) / widthCard)
    return totalItems
  }

  if (!courses?.length) return null

  return (
    <div className="more-viewed-programs--layout">
      <h2>Programas más vistos</h2>
      <LoadingWrapper loading={isLoading}>
        <>
          {!isMovil && courses?.length && (
            <Slider
              arrows={true}
              className='more-viewed-programs--slider'
              infinite={(courses?.length >= getNumberItems()) ? true : false}
              slidesToShow={getNumberItems()}
              nextArrow={<BsChevronRight color='var(--primary)' />}
              prevArrow={<BsChevronLeft color='var(--primary)' />}
            >
              {courses?.map((course) => (
                <div key={course._id} className='more-viewed-programs--item-slider'>
                  <FilterCourseCard
                    modality={course.schedulingMode?.name}
                    name={course.program?.name}
                    startDate={moment(course.startDate?.replace('T00:00:00.000Z', '')).format('DD/MM/YYYY')}
                    duration={course.duration}
                    courseId={course._id}
                    slug={course?.extra_info?.slug as string}
                    image={course.extra_info?.coverUrl}
                    schedule={course.schedule}
                    serviceInformation={course?.serviceInformation}
                    height={cardHeight ? `${cardHeight}px` : undefined}
                    sharePosition='dropup'
                    withoutTutor={course?.withoutTutor}
                    formationType={course?.extra_info?.formationType}
                    quickLearning={course?.quickLearning}
                    isMooc={course?.typeCourse === CourseSchedulingCourseType.MOOC}
                  />
                </div>
              ))}
            </Slider>
          )}
          {isMovil && courses?.length && (
            <div className="more-viewed--cards-container-movil">
              {courses?.slice(0, 3)?.map((course) => (
                <FilterCourseCard
                  modality={course.schedulingMode?.name}
                  name={course.program?.name}
                  startDate={moment(course.startDate).format('DD/MM/YYYY')}
                  duration={course.duration}
                  courseId={course._id}
                  slug={course?.extra_info?.slug as string}
                  image={course.extra_info?.coverUrl}
                  schedule={course.schedule}
                  key={course._id}
                  serviceInformation={course?.serviceInformation}
                  withoutTutor={course?.withoutTutor}
                  formationType={course?.extra_info?.formationType}
                  quickLearning={course?.quickLearning}
                  isMooc={course?.typeCourse === CourseSchedulingCourseType.MOOC}
                />
              ))}
            </div>
          )}
        </>
      </LoadingWrapper>
      <Link to={routingService.getPublicPath('/academic-filter')}>
        <p className='more-viewed-programs--more-text'>
          Consultar toda la programación
        </p>
      </Link>
    </div>
  )
}

export default MoreViewedProgramsModule
